<template>
    <section v-if="posts.length > 0" class="mb-16">
        <div class="flex items-center justify-between mb-8">
            <h2 class="text-3xl font-bold text-gray-900 dark:text-white">{{ title }}</h2>
            <NuxtLink
                v-if="showViewAll"
                to="/blog"
                class="text-primary-600 dark:text-primary-300 hover:text-primary-700 hover:dark:text-primary-300 font-medium flex items-center gap-2"
            >
                Všetky články
                <Icon name="heroicons:arrow-right" class="size-5" />
            </NuxtLink>
        </div>

        <!-- Masonry Posts Grid -->
        <CMasonryGrid :items="posts" :column-width="280" :gap="24" :ssr-columns="3" mode="masonry">
            <template #default="{ item, index }">
                <BlogPostCard :post="item" :priority="index === 0" />
            </template>
        </CMasonryGrid>
    </section>
</template>

<script setup lang="ts">
import type { BlogPost } from '#shared/types/Blog'
import CMasonryGrid from '@/components/ui/CMasonryGrid.vue'

withDefaults(
    defineProps<{
        posts: BlogPost[]
        title?: string
        showViewAll?: boolean
    }>(),
    {
        title: 'Najnovšie články',
        showViewAll: true
    }
)
</script>
